
import { Component, Vue } from "vue-property-decorator";
import ArrowPhotoOverlayIcon from "@/icons/ArrowPhotoOverlayIcon.vue";
import { NavigationStore } from "../store/navigation";

@Component({ components: { ArrowPhotoOverlayIcon } })
export default class AppShopNavigation extends Vue {
  NavigationStore: any = NavigationStore;
}
